module.exports = __webpack_public_path__ + "static/media/volunt.17a86abf.png";